import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";

const TransportMoto = () => {
  return (
    <div className="about-page">
      <>
          <Helmet>
              <title>Pro Moto - transport motocykli</title>
              <meta
              name="description"
              content="PRO MOTOT
                Bezpieczny door-to-door transport motocykli w całej Polsce. 
                Pasy, najazdy, ubezpieczenie cargo w cenie."
              />
              <link rel="canonical" href="https://promotoserwis.pl/transport-motocykli" />
          </Helmet>
      </>
      <section className="about-hero">
        <div className="about-hero__content">
          <motion.h1
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>Transport </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>    
              Bezpieczny door-to-door transport motocykli w całej Polsce. 
              Pasy, najazdy, ubezpieczenie cargo w cenie.
          </motion.p>
            <motion.p
              initial={{ opacity: 0, y: 80 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}>
              <strong>
                Zamów termin już teraz!
              </strong>
          </motion.p>


          <button
            className="about-scroll-btn"
            onClick={() =>
              document.querySelector(".about-extra").scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="arrow"></span>
          </button>
        </div>
      </section>


      <section className="about-extra">
        <div className="about-extra__container">

          <div className="about-block">
            <h2>Dlaczego Pro Moto?</h2>
            <ul>
                <li>specjalistyczny bus z prowadnicami i najazdami,</li>
                <li>miękkie pasy typu soft-loop i maty antypoślizgowe – zero rys na owiewkach,</li>
                <li>polisa cargo w cenie usługi – to my zajmujemy się ewentualnym odszkodowaniem,</li>
                <li>szybkie terminy – często odbiór tego samego lub następnego dnia,</li>
            </ul>
          </div>

          <div className="about-block">
            <h2>Jak to działa?</h2>
            <ul>
              <li><strong>Rezerwacja telefoniczna lub mailowa</strong> – podajesz datę, adres i typ motocykla.</li>
              <li><strong>Potwierdzenie SMS-em</strong>– otrzymujesz dokładny slot czasowy i numer kierowcy.</li>
              <li><strong>Załadunek </strong> – robimy zdjęcia stanu motocykla, mocujemy pasy i podpisujemy protokół.</li>
              <li><strong>Bezpieczny rozładunek </strong> – odbiorca sprawdza motocykl, podpisuje odbiór, a Ty dostajesz info, że dostawa zakończona.</li>
            </ul>
          </div>

          <div className="about-block about-block--final">
            <h2>Gdzie jeździmy?</h2>
            <ul>
                <li><strong>Poznań & powiat Poznański</strong> – ekspresowy odbiór w promieniu 30 km.</li>
                <li><strong>Wyjazdy specjalne</strong> – track-day, zlot, serwis w innym mieście?
                 Dogadamy termin indywidualnie.
                 Potrzebujesz transportu na Słowację lub do Niemiec? 
                 Daj znać – organizujemy też wyjazdy zagraniczne.</li>
            </ul>
          </div>
          <div className="about-block about-block--final">
            <h2>Kiedy warto skorzystać?</h2>
            <ul>
                <li>Zakup lub sprzedaż motocykla na odległość</li>
                <li>Sezonowy serwis</li>
                <li>Dostawa na tor lub zlot, żeby nie zużywać opon po drodze</li>
            </ul>
          </div>
          <div className="about-block about-block--final">
            <h2>Najczęstsze pytania</h2>
            <ul>
                <p>
                    <strong>Czy przewozicie więcej niż jeden motocykl naraz?</strong> <br/>
                    Tak, bus mieści do trzech motocykli; każdy przypięty osobno.
                </p>
                <p>
                    <strong>Czy muszę opróżniać bak z paliwa?</strong> <br/>
                    Nie – wystarczy zakręcić kranik lub dopilnować, by korek był szczelny.
                </p>
                <p>
                    <strong>Czy termin można zmienić w ostatniej chwili?</strong> <br/>
                    Do 24 h przed odbiorem – bezpłatnie. Później pobieramy symboliczną opłatę za przeplanowanie trasy.
                </p>
            </ul>
          </div>
          <div className="about-block about-block--final">
            <h2>Zarezerwuj transport</h2>
            <ul>
                <p>
                    Zadzwoń pod <strong>+48 535 744 816</strong> lub WhatsApp – oddzwonimy, potwierdzimy szczegóły i odbierzemy Twój motocykl wtedy, gdy Tobie pasuje.
                </p>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TransportMoto;
